function format(str) {
  for (var _len = arguments.length, subs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    subs[_key - 1] = arguments[_key];
  }

  var i = 0;
  return str.replace(/%[s%]/g, function (match) {
    if (match === "%%") return "%";
    var sub = subs[i++];
    return typeof sub !== "undefined" ? String(sub) : match;
  });
}

export { format };
